import React from "react";
import * as PropTypes from "prop-types";
import FormControl from "@mui/material/FormControl";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import NativeSelect from "@mui/material/NativeSelect";
import { withTranslation } from "react-i18next";

const IndicatorSelector = ({ t, ...rest }) => (
    <div className={rest.className}>
        <FormControl>
            <InputLabel
                variant="standard"
                htmlFor="input"
                shrink={true}
            >
                {t("Indicator")}
            </InputLabel>

            <NativeSelect
                input={<Input id="input" />}
                value={rest.value}
                onChange={(e) => rest.onChange(e.target.value)}
            >
                {rest.indicators.map((indicator) => (
                    <option
                        key={indicator.value}
                        value={indicator.value}
                    >
                        {t(indicator.label)}
                    </option>
                ))}
            </NativeSelect>
        </FormControl>
    </div>
);

IndicatorSelector.propTypes = {
    indicators: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        })
    ).isRequired,
    value: PropTypes.string,
    className: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};

export default withTranslation()(IndicatorSelector);
